// extracted by mini-css-extract-plugin
module.exports = {"select":"src-screens-Appointments-components-Select-Select-module__select--30WOe"};